export function Logo({ size = 28, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div
        style={{
          width: size,
          height: size,
          background: "#E60012",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <svg viewBox="0 0 24 24" width={size * 0.7} height={size * 0.7} fill="none">
          {/* aircraft/arrow */}
          <path d="M12 3 L16 9 L12 7.5 L8 9 Z" fill="#fff" />
          {/* car silhouette */}
          <path
            d="M3 16 Q3 13 7 13 L17 13 Q21 13 21 16 L21 18 L3 18 Z"
            fill="#fff"
          />
          <circle cx="7" cy="18.5" r="1.6" fill="#E60012" stroke="#fff" strokeWidth="0.6" />
          <circle cx="17" cy="18.5" r="1.6" fill="#E60012" stroke="#fff" strokeWidth="0.6" />
        </svg>
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-white" style={{ fontWeight: 900, fontSize: size * 0.55, letterSpacing: "-0.04em" }}>
            iAAM
          </div>
          <div className="label-mono mt-0.5" style={{ fontSize: 8 }}>
            Aerospace × Automotive
          </div>
        </div>
      )}
    </div>
  );
}
